import { computed, ref } from 'vue'

/**
 * The svg path for the icon
 */
const path = ref('M17.5102 0C7.83957 0 0 7.87366 0 17.5863C0 26.4817 14.6597 42.2276 17.1437 44.8451C17.2361 44.9439 17.365 45 17.5 45C17.635 45 17.7639 44.9439 17.8563 44.8451C20.3403 42.248 35 26.4408 35 17.5863C35 7.88164 27.1728 0.0112845 17.5102 0Z')

/**
 * The default size of the icon (relative to the path)
 */
const size = ref({
    width  : 35,
    height : 45
})

/**
 * The icon for the map marker
 */
const icon = computed(() => ({
    path        : path.value,
    fillOpacity : 1,
    fillColor   : '#ff9015',
    strokeColor : '#ff9015',
    size        : size.value,
    labelOrigin : { //The label should be horizontally centered and just above the center vertically
        x: size.value.width / 2, 
        y: size.value.height / 2 - 5
    },
}))

export function createMap(){
    return {
        icon   : icon,
        path   : path,
        size   : size,

        /**
         * Creates a marker for the MapMarker
         * 
         * @param {String} label 
         * @param {Number} zIndex 
         * @returns {Computed<Object>}
         */
        marker : (label, zIndex) => {
            return {
                icon  : icon.value,
                label : {
                    text       : String(label),
                    fontWeight : '900', //Must be a string...
                    color      : '#FFFFFF'
                },
                zIndex: zIndex //This fixes a bug where the text on the icons overlaps if they're in identical locations
            }
        }
    }
}